import styled from 'styled-components';

export const ChildTablesGroup = styled.div`
  padding: 30px;
  width: 100%;
  text-align: center;
  line-height: 75px;
`;

